import { SetupStep1Form } from '../components/SetupStep1Form';
import { SetupStep2Form } from '../components/SetupStep2Form';
import { SetupStep3Form } from '../components/SetupStep3Form';
import { useSetupWizardStore } from '../store/setup-wizard.store';

interface Props {
  onCompleted: () => void;
}

export function SetupWizardPage({ onCompleted }: Props) {
  const step = useSetupWizardStore((s) => s.step);

  return (
    <div className="min-h-[100dvh] bg-gradient-to-br from-emerald-50 via-white to-[#eef2ff] py-12">
      <div className="mx-auto max-w-3xl px-4">
        <header className="mb-8">
          <p className="text-[0.72rem] font-semibold uppercase tracking-[0.18em] text-emerald-800/95">
            Square ISO
          </p>
          <h1 className="mt-3 text-[1.875rem] font-semibold tracking-tight text-slate-900 sm:text-[2.1rem]">
            Bienvenue
          </h1>
          <p className="mt-3 text-[0.95rem] leading-relaxed text-slate-600">
            Initialisez la plateforme en 3 étapes. Vous deviendrez le super-administrateur.
          </p>
        </header>

        <ol className="mb-10 flex gap-2 text-sm">
          {[1, 2, 3].map((s) => (
            <li
              key={s}
              className={`flex-1 rounded-xl border px-3 py-2 text-center ${
                step === s
                  ? 'border-emerald-500 bg-emerald-50 text-emerald-900'
                  : step > s
                    ? 'border-emerald-200 bg-emerald-50/50 text-emerald-700'
                    : 'border-slate-200 bg-white text-slate-500'
              }`}
            >
              Étape {s}
            </li>
          ))}
        </ol>

        <div className="app-card p-7 sm:p-9">
          {step === 1 && <SetupStep1Form />}
          {step === 2 && <SetupStep2Form />}
          {step === 3 && <SetupStep3Form onCompleted={onCompleted} />}
        </div>
      </div>
    </div>
  );
}
